import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "framer-motion";
import { StrictMode, useState } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./index.css";
import { getTelegram } from "./lib/telegram.js";
import { makeTrpcClient, trpc } from "./trpc.js";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("root element not found");
}

const tg = getTelegram();
if (tg) {
  tg.ready();
  tg.expand();
  tg.setHeaderColor?.("#f5efe4");
  tg.setBackgroundColor?.("#f5efe4");
  // Bot API 7.7+ — свайп «вниз закрыть» блокируется, чтобы онбординг
  // не закрывался случайно при прокрутке письма.
  tg.disableVerticalSwipes?.();
  // Bot API 8.0+ — fullscreen + портретная ориентация. Методы
  // no-op на старых клиентах, optional-chaining достаточно.
  tg.requestFullscreen?.();
  tg.lockOrientation?.("portrait");
}

const devFrame = import.meta.env.DEV && !tg;
if (devFrame) {
  document.documentElement.classList.add("dev-frame");
}

const apiUrl: string = import.meta.env.VITE_API_URL ?? "http://localhost:3000";

function Root() {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(() => makeTrpcClient(apiUrl));
  const tree = (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <MotionConfig reducedMotion="user">
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MotionConfig>
      </QueryClientProvider>
    </trpc.Provider>
  );
  return devFrame ? <div className="dev-frame-shell">{tree}</div> : tree;
}

createRoot(rootElement).render(
  <StrictMode>
    <Root />
  </StrictMode>
);
